import { ISinhVienSearchRequest } from "../../model/request/sinh-vien/ISinhVienSearchRequest";
import { apiClient, formatQueryString } from "../apiClient";
export const sinhVienApi = {
  SelectByLops: (id_lops: number[]) => apiClient.get(`sinh-vien?${id_lops.map(x => `id_lops=${x}`).join("&")}`),
  SelectByDaoTaos: (id_dts: number[]) => apiClient.get(`sinh-vien/dao-tao?${id_dts.map(x => `id_dts=${x}`).join("&")}`),
  Search: (request: ISinhVienSearchRequest) => apiClient.get(`sinh-vien/search?${formatQueryString(request)}`),
  SelectMonDaHoc: (id_sv:string) => apiClient.get(`sinh-vien/${id_sv}/mon-da-hoc`),
};
